/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum PurchasingDecisionTimeline {
  ASAP = "asap",
  _1_TO_3_MONTHS = "1_to_3_months",
  _3_TO_6_MONTHS = "3_to_6_months",
  _6_TO_12_MONTHS = "6_to_12_months",
  MORE_THAN_12_MONTHS = "more_than_12_months",
}
